import AttachmentItemFile from './AttachmentItemFile';
import Base64InlineImageFile from './Base64InlineImageFile';
import CloudFile from './CloudFile';
import LocalComputerFile from './LocalComputerFile';
import MailItemFile from './MailItemFile';
import UriFile from './UriFile';

type AttachmentFile =
    | LocalComputerFile
    | Base64InlineImageFile
    | CloudFile
    | MailItemFile
    | UriFile
    | AttachmentItemFile;

export default AttachmentFile;

/**
 * Enum is used in scorecards and reports.
 * Please add any new values at the end.
 */
export enum AttachmentFileType {
    Base64InlineImage = 0,
    Cloud = 1,
    Local = 2,
    MailItem = 3,
    Uri = 4,
    AttachmentItem = 5,
    CloudSuggestion = 6,
    AttachmentItemSuggestion = 7,
    Inline = 8,
    Smime = 9,
    FilesHub = 10,
    GroupFilesHub = 11,
    MailSearchFileSuggestion = 12,
    Unknown = 13,
    ContextualSuggestion = 14,
}

export interface AttachmentFileList {
    readonly length: number;
    readonly [index: number]: AttachmentFile;
}
